import urls from "../../../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../../../utils/service";

export async function getAllDepartmentWithDesignation() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETALLDEPARTMENTWITHDESIGNATION,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
